import React from 'react';
import { KeyboardDatePicker as MuiKeyboardDatePicker, KeyboardDatePickerProps as MuiKeyboardDatePickerProps } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Field, FieldProps } from 'formik';
import { get, getOr } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';

type KeyboardDatePickerProps = Omit<MuiKeyboardDatePickerProps, 'onChange' | 'value'>;

type CombinedProps = FieldProps<ParsableDate>['field'] & KeyboardDatePickerProps;

const StyledKeyboardDatePicker = styled(MuiKeyboardDatePicker)`
    .MuiOutlinedInput-input {
        padding: 11px;
    }
    .MuiIconButton-root {
        padding: 8.5px;
    }
`;

const KeyboardDatePicker = ({ value, onChange, name, error, ...other }: CombinedProps) => {
    const handleChange = (date: MaterialUiPickersDate) => {
        onChange({ target: { name, value: date ? date.toJSDate() : null } });
    };

    return (
        <StyledKeyboardDatePicker
            value={value}
            onChange={date => handleChange(date)}
            {...other}
        />
    );
};

interface KeyboardDateFieldProps extends KeyboardDatePickerProps {
    name: string;
    label?: string;
}

const KeyboardDateField = <T,>(
    { name, label, ...other }: KeyboardDateFieldProps
) => {
    const { t } = useTranslation();
    return (
        <Field
            id={name}
            name={name}
            label={label}
            component={({ form: { errors, touched }, field }: FieldProps<ParsableDate, T>) => {
                const error= Boolean(get(name, errors)) && get(name, touched);
                const helperText= get(name, touched) ? t(getOr(' ', name, errors) as string) : undefined;
                return <KeyboardDatePicker {...field} error={!!error} helperText={helperText} inputVariant="outlined" {...other} />;
            }}
        />
    );
};

export default KeyboardDateField;
